/**
 * Reglages de l'app, figes au build.
 *
 * API_BASE_URL : VITE_API_URL (https://api.amabec.ca en prod, sans /api).
 * Sans VITE_API_URL : le backend local si la caisse tourne sur localhost,
 * sinon l'API de prod (meme repli que frontend-b2b).
 * APP_VERSION : injectee par vite.config.mjs (__CAISSE_APP_VERSION__),
 * envoyee dans le battement de coeur et affichee sur le poste.
 */
const isLocalhost = typeof window !== 'undefined'
    && ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const API_BASE_URL = (import.meta.env.VITE_API_URL
    || (isLocalhost ? 'http://localhost:3002' : 'https://api.amabec.ca')).replace(/\/+$/, '');

// eslint-disable-next-line no-undef
export const APP_VERSION = typeof __CAISSE_APP_VERSION__ === 'string' ? __CAISSE_APP_VERSION__ : 'dev';

/** Battement de coeur : 30 s (le serveur en accepte un toutes les 10 s par poste). */
export const HEARTBEAT_INTERVAL_MS = 30_000;

/** Verification d'une nouvelle version de l'app, en ligne : toutes les 30 min. */
export const UPDATE_CHECK_INTERVAL_MS = 30 * 60_000;
